import {
  type FirebaseApp,
  type FirebaseOptions,
  initializeApp,
} from "firebase/app";
import { type Auth, connectAuthEmulator, getAuth } from "firebase/auth";

import { env } from "./env";

const config = {
  apiKey: env.VITE_FIREBASE_API_KEY,
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: env.VITE_FIREBASE_APP_ID,
} satisfies FirebaseOptions;

let app: FirebaseApp;
let auth: Auth;

export function initFirebase() {
  app = initializeApp(config);
  auth = getAuth(app);

  // Connect to emulator in development
  if (
    env.VITE_APP_ENV === "local" &&
    env.VITE_FIREBASE_USE_EMULATOR &&
    !auth.emulatorConfig
  ) {
    console.info("Connecting to Firebase emulator");
    connectAuthEmulator(auth, "http://localhost:9099");
  }

  return { app, auth };
}

export function getFirebaseAuth(): Auth {
  if (!auth) {
    throw new Error("Firebase not initialized. Call initFirebase() first.");
  }
  return auth;
}
